import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { FaSearch, FaCalendar, FaDollarSign, FaCheckCircle, FaClock } from 'react-icons/fa';
import AppContext from '../../../context/AppContext';
import { useNavigate } from 'react-router-dom';


const PackageBookings = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ search: '', status: 'all', payment: 'all' });
const navigate = useNavigate();
  useEffect(() => { fetchBookings(); }, []);

  const fetchBookings = () => {
    axios
      .get(`${baseUrl}/admin/packages-booking`, {
        headers: { Authorization: `Bearer ${authToken}` }
      })
      .then((response) => {
        if (response.data.success) setBookings(response.data.data);
      })
      .catch((error) => console.error('Booking fetch error:', error))
      .finally(() => setLoading(false));
  };
  const handleView = (id) => {
    navigate(`/admin/packages/package-bookings/${id}`);
  };

  const filteredBookings = bookings.filter((booking) => {
    const packageName  = booking.jjpackage?.package_name?.toLowerCase() || '';
    const customerName = booking.jjcustomer?.cus_username?.toLowerCase() || '';
    const searchText   = filters.search.toLowerCase();
    const matchesSearch  = packageName.includes(searchText) || customerName.includes(searchText);
    const matchesStatus  = filters.status  === 'all' || booking.booking_status === filters.status;
    const matchesPayment = filters.payment === 'all' || booking.payment_status  === filters.payment;
    return matchesSearch && matchesStatus && matchesPayment;
  });

  const totalBookings    = bookings.length;
  const confirmedBookings = bookings.filter(b => b.booking_status === 'confirmed').length;
  const pendingBookings   = bookings.filter(b => b.booking_status === 'pending').length;

  // badge class helper
  const bookingBadgeClass = (status) => {
    const map = { confirmed: 'adm-pkg-badge-confirmed', pending: 'adm-pkg-badge-pending', cancelled: 'adm-pkg-badge-cancelled' };
    return `adm-pkg-badge ${map[status] || 'adm-pkg-badge-pending'}`;
  };

  const paymentBadgeClass = (status) => {
    const map = { paid: 'adm-pkg-badge-paid', partial: 'adm-pkg-badge-partial', pending: 'adm-pkg-badge-payment-pending' };
    return `adm-pkg-badge ${map[status] || 'adm-pkg-badge-payment-pending'}`;
  };

  if (loading) {
    return (
      <div className="adm-pkg-loading-state">
        <div className="adm-pkg-spinner" />
        <p>Loading bookings...</p>
      </div>
    );
  }

  return (
    <div className="adm-pkg-bookings-container">

      <div className="adm-pkg-booking-stats">

        <div className="adm-pkg-booking-stat-card">
          <div className="stat-icon-wrap stat-icon-blue">
            <FaCalendar />
          </div>
          <div>
            <h3>{totalBookings}</h3>
            <p>Total Bookings</p>
          </div>
        </div>

        <div className="adm-pkg-booking-stat-card">
          <div className="stat-icon-wrap stat-icon-green">
            <FaCheckCircle />
          </div>
          <div>
            <h3>{confirmedBookings}</h3>
            <p>Confirmed</p>
          </div>
        </div>

        <div className="adm-pkg-booking-stat-card">
          <div className="stat-icon-wrap stat-icon-amber">
            <FaClock />
          </div>
          <div>
            <h3>{pendingBookings}</h3>
            <p>Pending</p>
          </div>
        </div>
      </div>

      <div className="adm-pkg-booking-filters">
        <div className="adm-pkg-search-wrapper">
          <FaSearch className="adm-pkg-search-icon-inner" />
          <input
            type="text"
            placeholder="Search by package or customer..."
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          />
        </div>
      </div>

      <div className="adm-pkg-booking-table-wrapper">
        <table className="adm-pkg-booking-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Package</th>
              <th>Customer</th>
              <th>Phone</th>
              <th>Booking Date</th>
              <th>Departure Date</th>
              <th>Amount</th>
              <th>Booking Status</th>
              <th>Payment Status</th>
              <th>Actions</th>

            </tr>
          </thead>
          <tbody>
            {filteredBookings.length === 0 ? (
              <tr>
                <td colSpan="8" className="adm-pkg-table-empty">No bookings found</td>
              </tr>
            ) : (
              filteredBookings.map((booking) => (
                <tr key={booking.id}>
                  <td className="adm-pkg-booking-id">#{booking.id}</td>
                  <td>{booking.jjpackage?.package_name}</td>
                  <td>{booking.jjcustomer?.cus_username}</td>
                  <td>{booking.phone_no}</td>
                   <td>{booking.created_at?.split('T')[0]}</td>
                  <td>{booking.checkIn?.split('T')[0]}</td>
                  <td><strong>PKR {Number(booking.total_amount).toLocaleString()}</strong></td>
                  <td><span className={bookingBadgeClass(booking.booking_status)}>{booking.booking_status}</span></td>
                  <td><span className={paymentBadgeClass(booking.payment_status)}>{booking.payment_status}</span></td>
                  <td><button
                    className="adm-pkg-view-btn"
                    onClick={() =>
                    navigate(`/admin/packages/package-bookings/${booking.id}`)
                    }
                    >
                    View Details
                   </button></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
};
export default PackageBookings;